module.exports = __webpack_public_path__ + "static/media/Screenshot_3-thumb.3f62b7f8.png";